import { useState, useCallback } from 'react';
import { pwh201Api } from '../../../services/pwh201Api';
import type { FH110 } from '../../../services/pwh201Api';

export function usePWH201Navigation() {
  const [list, setList] = useState<FH110[]>([]);
  const [total, setTotal] = useState(0);
  const [currentIdx, setCurrentIdx] = useState(0);

  const fetchList = useCallback(async (page = 1, size = 50) => {
    try {
      const res = await pwh201Api.list(page, size);
      setList(res.data || []);
      setTotal(res.total);
    } catch {
      // ignore
    }
  }, []);

  const hasPrev = currentIdx > 0;
  const hasNext = currentIdx < list.length - 1;

  const setCurrentById = useCallback((id: string) => {
    const idx = list.findIndex(r => r.fh110_01 === id);
    if (idx >= 0) setCurrentIdx(idx);
  }, [list]);

  const goFirst = useCallback(() => {
    if (list.length === 0) return null;
    setCurrentIdx(0);
    return list[0].fh110_01;
  }, [list]);

  const goLast = useCallback(() => {
    if (list.length === 0) return null;
    const last = list.length - 1;
    setCurrentIdx(last);
    return list[last].fh110_01;
  }, [list]);

  const goPrev = useCallback(() => {
    if (currentIdx <= 0) return null;
    const next = currentIdx - 1;
    setCurrentIdx(next);
    return list[next].fh110_01;
  }, [currentIdx, list]);

  const goNext = useCallback(() => {
    if (currentIdx >= list.length - 1) return null;
    const next = currentIdx + 1;
    setCurrentIdx(next);
    return list[next].fh110_01;
  }, [currentIdx, list]);

  return { list, total, hasPrev, hasNext, fetchList, goFirst, goLast, goPrev, goNext, setCurrentById };
}
